
import { getCurrentInstance, ref, computed } from "vue";
import authFooter from "@/modules/auth/components/authFooterComponent.vue";
import { WalletCredential } from "@/_models/Wallet";
import { xarcadeUser } from "@/_models/User";
import ResponseData from "@/_models/ResponseData";
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Helper } from "@/utils/Helper";

export default {
  name: "viewAuthLogin",
  components: {
    authFooter,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const login = ref({
      username: "",
      password: "",
    });

    const developerRole = ref("1");

    const activeSection = ref("username");
    const errorSection = ref(false);
    const errorMessage = ref("");
    const showPassword = ref(false);

    const retrieveXarcadeUser = () => {
      activeSection.value = "loadingUsername";

      XarcadeAccountService.getXarcadeUser(login.value.username)
        .then((response: ResponseData) => {
          if (response.status === 200) {
            errorSection.value = false;
            activeSection.value = "login";
          } else {
            activeSection.value = "username";
            Helper.endpointErrorHandling('', 'User not found!');
          }
        })
        .catch((error) => {
          errorSection.value = true;
          activeSection.value = "username";
          errorMessage.value = Helper.endpointErrorHandling(error);
        });
    };

    const enableMainnet = computed(() => {
      return store.getters['config/getEnableMainnet'];
    });

    const updateXarcadeUserRole = () => {
      let userData = store.getters['auth/user'] ?? "";
      let jwtToken = store.getters['auth/jwtToken'] ?? "";
      let formData = new FormData();

      formData.append("UserRole", "1") //Dev Role

      XarcadeAccountService.updateUserDetails(userData.userId, jwtToken, formData)
        .catch((error) => {
              Helper.endpointErrorHandling(error);
              console.log(error.response);
        });
    };

    const loginUser = () => {
      let data = {
        username: login.value.username,
        password: login.value.password,
      };

      activeSection.value = "loadingLogin";

      // store username to localstorage
      if (remember_username.value) {
        localStorage.setItem("username", login.value.username);
      } else {
        localStorage.removeItem("username");
      }

      activeSection.value = "loadingLogin";

      XarcadeAccountService.loginUser(data, 'testnet')
        .then(async(response: ResponseData) => {
          if (response.data["success"]) {
            // fetch wallet address and public key
            // testnet
            const testnetCredentials = await XarcadeAccountService.getTestnetWallet( response.data["authenticationData"]["account"].userId, response.data["authenticationData"]["jwtToken"]);
            // mainnet
            let mainnetCredentials:any;
            if(enableMainnet.value){
              // login to mainnnet
              await XarcadeAccountService.loginUser(data, 'mainnet').then(async(res:ResponseData) => {
                mainnetCredentials = await XarcadeAccountService.getMainnetWallet( res.data["authenticationData"]["account"].userId, res.data["authenticationData"]["jwtToken"]);
                store.dispatch("auth/mainnetLogin", {
                  mainnetJwtToken: res.data["authenticationData"]["jwtToken"],
                });
              });
            }else{
              mainnetCredentials = '';
            }

            let userData:xarcadeUser = {
              userId: response.data["authenticationData"]["account"].userId,
              firstName: response.data["authenticationData"]["account"].firstName,
              lastName: response.data["authenticationData"]["account"].lastName,
              email: response.data["authenticationData"]["account"].email,
              username: response.data["authenticationData"]["account"].username,
              password: response.data["authenticationData"]["account"].password,
              userRole: response.data["authenticationData"]["account"].userRole,
              displayName: response.data["authenticationData"]["account"].displayName,
              introduction: response.data["authenticationData"]["account"].introduction,
              websiteUrl: response.data["authenticationData"]["account"].websiteUrl,
              profileStream: response.data["authenticationData"]["account"].profileStream,
              profilePicture: response.data["authenticationData"]["account"].profilePicture,
              country: response.data["authenticationData"]["account"].country,
              company: response.data["authenticationData"]["account"].company,
              gender: response.data["authenticationData"]["account"].gender,
              phone: response.data["authenticationData"]["account"].phone,
              acceptTerms: response.data["authenticationData"]["account"].acceptTerms,
              testnetPublicAddress: testnetCredentials.data.publicAddress,
              testnetWalletAddress: testnetCredentials.data.walletAddress,
              mainnetPublicAddress: enableMainnet.value?mainnetCredentials.data.publicAddress:'',
              mainnetWalletAddress: enableMainnet.value?mainnetCredentials.data.walletAddress:''
            };

            let date = new Date();
            store.dispatch("auth/login", {
              userData: userData,
              jwtToken: response.data["authenticationData"]["jwtToken"],
            });
            localStorage.setItem("expiry", date.setHours(date.getHours() + 2).toString());

            localStorage.setItem("tooltip", "show");

            if (userData.userRole === 0) {
              updateXarcadeUserRole();
            }

            const toUrl = sessionStorage.getItem("tourl");
            if (toUrl) {
              sessionStorage.removeItem("tourl");
              router.push({ path: toUrl });
            } else {
              router.push({ name: "viewDashboard" });
            }
          }
        })
        .catch((error) => {
          console.log(error)
          errorSection.value = true;
          errorMessage.value = Helper.endpointErrorHandling(error);
          activeSection.value = "login";
        });
    };

    const remember_username = ref(false);
    if (localStorage.getItem("username")) {
      login.value.username = localStorage.getItem("username");
      remember_username.value = true;
    } else {
      remember_username.value = false;
    }

    emitter.on('SWITCH_TO_USERNAME_LOGIN', () => {
      activeSection.value = 'username';
    });

    return {
      retrieveXarcadeUser,
      loginUser,
      updateXarcadeUserRole,
      errorMessage,
      errorSection,
      activeSection,
      login,
      remember_username,
      showPassword,
    };
  },
};
